import React from "react";

const LogoSvgLight = ({ primaryColor = '#231f20', secondaryColor = '#fdc30b' }) => {
  return (
    <svg
    className="w-full hidden dark:block"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1127.31 423.49"
    fill="none"
  >
    <g>
      <path
        fill={primaryColor}
        d="M145.88,215.51c3.23-56.75,31.64-101.75,88.6-127.35,6.93-3.11,8.85-6.34,7.59-13.56-3.74-21.47-17.17-33.93-40.4-36.56-12.11-1.37-18.88-7.57-19.37-17.76-.56-11.42,7.16-19.78,18.67-20.24,38.68-1.53,74.32,29.66,78.79,69.33.61,5.43,1.54,8.81,7.87,7.46,4.92-1.05,11.3,3.57,12.61-7.27C305.03,29.95,338.26.19,376,.05c13.05-.05,21.32,6.8,21.85,18.11.51,10.87-6.77,18.38-19.27,19.88-24.31,2.91-38.88,16.95-40.9,39.04-.47,5.18.73,8.02,6.06,10.3,97.89,41.82,120.81,162.09,45.55,237.59-31.39,31.49-62.57,63.19-93.61,95.03-4.38,4.49-6.72,4.77-11.25.1-32.5-33.38-65.53-66.26-97.96-99.71-26.85-27.71-39.76-61.38-40.59-104.88ZM371.11,221.12c.27-44.31-35.9-81.27-79.92-81.68-45.08-.42-82.52,36.38-82.52,81.12,0,44.16,36.56,80.97,80.6,81.14,45.06.17,81.58-35.78,81.84-80.58Z"
      />
      <path
        fill={secondaryColor}
        d="M93.98,192.23c-13.73-.6-29.3,1.62-44.45-3.81C20.23,177.92.29,150.51,0,119.49c-.29-31.89,18.5-59.31,48.35-70.6,28.93-10.93,61.95-2.36,82.13,21.27,10.87,12.73,21.67,25.53,32.8,38.04,3.4,3.82,4.04,6.26.42,10.63-16.17,19.55-26.95,41.89-32.21,66.74-1.07,5.05-2.95,7.1-8.4,6.79-9.11-.51-18.27-.14-29.11-.14Z"
      />
      <path
        fill={secondaryColor}
        d="M484.72,192.23c-9.44,0-18.89-.12-28.33.06-4.05.08-6.56-.49-7.56-5.35-5.31-25.81-16.53-48.91-33.38-69.16-2.87-3.45-2.1-5.58.43-8.5,12.19-14.02,23.85-28.51,36.41-42.17,22.28-24.21,59.74-29.8,88.97-13.91,30.07,16.35,44.89,50.54,36.39,83.96-8.23,32.36-37.4,54.99-71,55.07-7.31.02-14.62,0-21.93,0Z"
      />
      <g>
        <path
          fill={secondaryColor}
          d="M710.7,200.16c-16.78,0-32.29,5.33-45,14.36v-60.58h-32.69v127.86h.1c2.05,41.06,36.01,73.75,77.59,73.75s77.71-34.79,77.71-77.71-34.79-77.68-77.71-77.68ZM710.7,322.79c-24.84,0-45-20.15-45-45s20.15-45.02,45-45.02,45.02,20.15,45.02,45.02-20.15,45-45.02,45Z"
        />
        <path
          fill={secondaryColor}
          d="M959.19,277.84c0-42.9-34.79-77.68-77.68-77.68s-77.71,34.79-77.71,77.68,34.79,77.71,77.71,77.71c30.9,0,57.6-18.05,70.11-44.17h-40.16c-7.96,7.08-18.44,11.41-29.95,11.41-19.25,0-35.69-12.12-42.12-29.12h118.21c1.05-5.11,1.59-10.41,1.59-15.83ZM839.69,261.13c6.62-16.61,22.84-28.36,41.82-28.36s35.2,11.75,41.82,28.36h-83.64Z"
        />
        <path
          fill={secondaryColor}
          d="M1127.31,277.84c0-42.9-34.79-77.68-77.71-77.68s-77.68,34.79-77.68,77.68,34.79,77.71,77.68,77.71c30.9,0,57.6-18.05,70.11-44.17h-40.16c-7.94,7.08-18.44,11.41-29.95,11.41-19.25,0-35.69-12.12-42.12-29.12h118.21c1.05-5.11,1.61-10.41,1.61-15.83ZM1007.78,261.13c6.62-16.61,22.84-28.36,41.82-28.36s35.2,11.75,41.82,28.36h-83.64Z"
        />
      </g>
    </g>
  </svg>
  );
};

export default LogoSvgLight;
